// StoredVariables
const StoredVariables = {
  logindata:
    "$2y$12$Sfgfr5xn80lXcy7Trr1Ix.8EZEd2/gGfp30OhEzOU13GDIWwZDeTC/$2y$12$Sfgfr5xn80lXcy7Trr1Ix.8EZEd2/gGfp.$2y$12$Sfgfr5xn80lXcy7Tr",
  username:
    "$12$Sfgfr5xn80lXcy7Trr1Ix.8EZEd20lXcy7Trr1Ix$///Gfp30OhEzOU13GDIWwZDeTC/$2y$12$Sfgfr$$Gfp30OhEzOU13GDIWwZDeTC/$2y$12$Sfgfr5$2y$12$Sfgfr5xn80lXcy7Tr",
  pathname:
    "$2y$12$Sfgfr5xn80lXcy7Trr1Ix.8EZEd2/gGfp30OhEzOU13GDIWwZDeTC/$2y$12$Sfgfr5xngfr5xn80lXcy7Trr1Ix$2y$12$Sf$2y$12$Sfgfr5xn80lXcy7Tr",
  role: "$12$Sfgfr5xn80lXcy7Trr1Ix.8EZEd20lfp30OhEzOU13GDIWwZDeTC/0OhEzOU13GDIWwZDeTC/$2y$12$Sfgfr5xngfr5xn80lXcy7Trr1Ix$2y$12$Sf$2y$12$Sfgfr5xn80lXcy7Tr",
  tabs: "$12$Sfgfr5xxn80lXcy7Trr1Ix$n80lXcy7Trr1Ix8Exn80lXcy7Trr1Ix$ZEd20lfp30Ohgfr5xxn80lXc/y7Trr1Ikkdklflkd$2y$12$Sfgfr5xn80lXcy7Tr",
  isProvider:
    "$0lXcyXcy7Trr1Ix$ZEd207TrXcy7Trr1Xcy7Trr1Ix$ZEd20IXcy7Trr1Ix$ZEd20x$ZEdXcy7Trr1Ix$ZEd2020$2y$12$Sfgfr5xn80lXcy7Tr",
  productId:
    "$2y$12$Sfgfr5xn80lXcy7Trr1Ix.8EZEd2n80lXcy7Trr1Ix$ZEd20lfp30Ohgfr5xxn80lXc/y7Trr1Ikkdklflkdr5xxn80lXc/y7T$2y$12$Sfgfr5xn80lXcy7Tr",
  email:
    "$2y$12$Sfgfr5xngfrr5xn80lXcy7Trr1Ix.8EZEd2n80lXcy7Trr1Ix$ZEd20lfp30Ohgfr5xxn80lXc/y7Trr1Ikkdklfl$2y$12$Sfgfr5xn80lXcy7Tr",
  forgot:
    "$2y$12$Sfgfr5xngfrr5xn80fr5xn80lXcy7Trr1Ix8EZEd20lfp3lXcy7Trr8EZEd2n80lXcy7Trr1Ix$ZEd20lfp30Ohgfr5xxn80lXc/y7Trr1Ikkdklfl$2y$12$Sfgfr5xn80lXcy7Tr",
  posttype:
    "$12$Sfgfr5xxn80lXcy7Trr1ngfrr5xn80fr5xn80lXcy7TIx$n80lXcy7Trr1Ix8Exn80lXcy7Trr1Ix$ZEd20lfp30Ohgfr5xxn80lXc/y7Trr1Ikkdklflkd$2y$12$Sfgfr5xn80lXcy7Tr",
  product:
    "$n80lXcy7Trr1ngfrr5xn80fr5xn80lfgfr5xngfrr5xnXcy7TIx$n80lXcy7Trr1Ix8Exn80lXcy7Trr1Ix$ZEd20lfp30Ohgfr5xxn80lXc/y7Trr1Ikkdklflkd$2y$12$Sfgfr5xn80lXcy7Tr",
  category:
    "$2a$10$jxLePXlMIocKlLvxzUsprOhGQI4RyoRt0jecHVX1Rf1/Tm5EA8jFKvxzUsprOhGQI4RyoRt0jecHVX1Rf1/Tm5EA8jFK$2y$12$Sfgfr5xn80lXcy7Tr",
  area: "$2a$10$jxLePXlMIocKlLvxzUsprOhGQI4RyoRt0jecHVX1Rf1/Tm5EA8jFKvxzUsprOhGQI4R2a$10$jxLePXlMIocKlLvxzUsprOhGQI4RyoRt0jecHVX1Rf1/Tm5EA8jFKvxzUsprOhGQI4R$2y$12$Sfgfr5xn80lXcy7Tr",
  FavData:
    "$2a$10$jxLePXlMIocKlLvxzUsprOhGQI4RyoRt0jecHVX1Rf1/Tm5EA8jFKvxzUsprOhGQI4R2a$10$jxLePXlMIocKlLvxzUsprOhGQI4RyoRt0jecHVX$2y$12$Sfgfr5xn80lXcy7Tr",
  maintenance:
    "$n80lXcy7Trr1ngfrr5xn80fr5xn80lfgfr5xtghtsdtrt657TIx$n80lXcy7Trr1Ix8Exn80lXcy7Trr1Ix$ZEd20lfp30Ohgfr5xxn80lXc/y7Trr1Ikkdklflkd$2y$12$Sfgfr5xn80lXcy7Tr",
  productImage:
    "ngfrr5xnjolkjfgfr5xngfrr5xnljljljlkjlkjgfr5xngfrr5xnXcy7TIx$n80lXxngfrr5xnjoi5xngfrrgfr5xngfrr$2y$12$Sfgfr5xn80lXcy7Tr",
  RememberMe:
    "MCgJDrpaOLCLPX9v2g62Jg==r5xngfrr5xnXcy7TIx$n80lXMCgJDrpaOLCLPX9v2g62Jg$2y$12$Sfgfr5xn80lXcy7Tr",
  password:
    "MCgJMCgJDrpaOLCLPX9v2g62Jg=$n80lXr5xngfrr5xnXcy7TIxDrpaOLCLPX9v2g62Jg$2y$12$Sfgfr5xn80lXcy7Tr",
  reload:
    "MCgJMCgJ=$n80lXr5xngfrr5DrpaOLCLPX9v2g62JgxnXcy7TIxDrpaOLDrpaOLCLPX9v2g62JgCLPX9v2g62Jg$2y$12$Sfgfr5xn80lXcy7Tr",
  checkout:
    "62JgxnXcy7TIxDrpaOLDrpaOLCLPX9v2g62JgCLPXIxDrpaOLDrpaOLCLPX99v2g62Jg$2y$12$Sfgfr5xn80lXcy7Tr",
};

// Session
export const SetSession = (key, data) => sessionStorage.setItem(key, data);
export const GetSession = (key) => sessionStorage.getItem(key);
export const RemoveSession = (key) => sessionStorage.removeItem(key);
export const ClearSession = (key) => sessionStorage.clear();
export const SetLocal = (key, data) => localStorage.setItem(key, data);
export const GetLocal = (key) => localStorage.getItem(key);

//Local Storage
export const SetLocalSession = (key, data) => localStorage.setItem(key, data);
export const GetLocalSession = (key) => localStorage.getItem(key);
export const RemoveLocalSession = (key) => localStorage.removeItem(key);

export default StoredVariables;
